import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  /** @type {((event: MouseEvent) => void) | undefined} */
  #recommendationCloseHandler;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.#bindRecommendationClose();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    // Remove listener to avoid duplicates on reconnect (Shopify morphing)
    const container = this.querySelector('.cart-drawer__modal-recommendations');
    if (container && this.#recommendationCloseHandler) {
      container.removeEventListener('click', this.#recommendationCloseHandler);
    }
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  #bindRecommendationClose() {
    const container = this.querySelector('.cart-drawer__modal-recommendations');
    if (!container) return;

    // Initialize handler once
    if (!this.#recommendationCloseHandler) {
      this.#recommendationCloseHandler = (event) => {
        if (event.target === container) {
          this.close();
        }
      };
    }

    // Prevent duplicates if reconnecting
    container.removeEventListener('click', this.#recommendationCloseHandler);
    container.addEventListener('click', this.#recommendationCloseHandler);
  }

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid
     * overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent =
        document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
